import { useCallback } from 'react'

export type UseMasterSelectionProps = {
  value?: string | null
  onChange: (masterUuid: string | null) => void
  onToggleChange: (isMasterEnabled: boolean) => void
  isMasterEnabled: boolean
  hasQuestionsWithMasterFieldReferences: boolean
}

export type UseMasterSelectionReturn = {
  isToggleOn: boolean
  handleToggleChange: (checked: boolean) => void
  selectedMaster: string | null
  handleMasterChange: (masterUuid: string | null) => void
  isToggleDisabled: boolean
  isMasterChangeDisabled: boolean
  disabledMessage: string
}

const DISABLED_MESSAGE =
  '質問に製品マスタの項目が紐づいているため、製品マスタの変更や解除はできません'

export const useMasterSelection = ({
  value,
  onChange,
  onToggleChange,
  isMasterEnabled,
  hasQuestionsWithMasterFieldReferences,
}: UseMasterSelectionProps): UseMasterSelectionReturn => {
  const isToggleOn = isMasterEnabled
  const selectedMaster = value ?? null

  // Toggle OFF・マスタ変更の無効化: 質問にマスタ項目参照がある場合
  const isDisabledByReference =
    hasQuestionsWithMasterFieldReferences && isToggleOn

  const handleToggleChange = useCallback(
    (checked: boolean) => {
      if (!checked) {
        onToggleChange(false)
        onChange(null)
      } else {
        onToggleChange(true)
      }
    },
    [onChange, onToggleChange],
  )

  const handleMasterChange = useCallback(
    (masterUuid: string | null) => {
      onChange(masterUuid)
    },
    [onChange],
  )

  return {
    isToggleOn,
    handleToggleChange,
    selectedMaster,
    handleMasterChange,
    isToggleDisabled: isDisabledByReference,
    isMasterChangeDisabled: isDisabledByReference,
    disabledMessage: isDisabledByReference ? DISABLED_MESSAGE : '',
  }
}
